<template>
  <div>
    <template v-if="activeTags">
      <tag
        v-for="(tag, index) in activeTags"
        :key="`tag${index}`"
        @closeClicked="removeTag(index)"
      >
        {{ tag }}
      </tag>
    </template>

    <template v-if="!userData">
      <landing-page />
    </template>

    <listing-loader
      page="all_for_sale"
      :tags="activeTags"
      :search="search"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ListingLoader from '@/components/ListingLoader.vue';
import LandingPage from '@/components/LandingPage.vue';
import Tag from '@/components/Tag.vue';

export default {
  metaInfo: {
    title: 'All For Sale',
  },
  components: {
    ListingLoader,
    LandingPage,
    Tag,
  },
  data() {
    return {
      loading: false,
      error: false,
    };
  },
  computed: {
    ...mapState([
      'feedItems',
      'activeTags',
      'search',
    ]),
  },
  methods: {
    removeTag(index) {
      this.$store.dispatch('remove_tag', index);
    },
  },
};
</script>
